import { render, staticRenderFns } from "./ViajeGuiaImport.vue?vue&type=template&id=2b164cec&scoped=true"
import script from "./ViajeGuiaImport.vue?vue&type=script&lang=js"
export * from "./ViajeGuiaImport.vue?vue&type=script&lang=js"
import style0 from "./ViajeGuiaImport.vue?vue&type=style&index=0&id=2b164cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b164cec",
  null
  
)

export default component.exports